import { render, staticRenderFns } from "./InfoBlock.vue?vue&type=template&id=3860a455"
var script = {}
import style0 from "./InfoBlock.vue?vue&type=style&index=0&id=3860a455&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports